import { CardSearch, ExportData, PageBodyHeader, Table } from "../../component";
import { useEffect, useState } from "react";
import { generalObj } from "../../constant/object_types";
import { useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { dateStr, fetchAllAboutToExpireProduct, fetchProductAboutToExpireReport } from "../../action/generalFunc";
import { toast } from "react-toastify";

const VendorAllAboutToExpire = () => {
    const [productList, setProductList] = useState<generalObj[]>([]);
    const [searchText, setSearchText] = useState<string>("");

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);

    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        (async () => {
            setModalLoading(true);
            (async () => {
                let expiry_result = await fetchAllAboutToExpireProduct(account.token)
                if (!expiry_result) {
                    window.history.back();
                }
                setProductList(expiry_result.expiry);
                setModalLoading(false)
            })();
            
        })();
    }, [account, setModalLoading]);

    const processExport = (export_type:string) => {
        generateReport(export_type);
    }

    const onSearch = (val:string) => {
        setProductList((prevProductList) => {
            return (
                prevProductList.filter((item) => {
                    if (item.name.toLowerCase().includes(val.toLowerCase()) || val.toLowerCase().includes(item.quantity) || item.size.toString().includes(val.toLowerCase()) || item.store.name.toString().includes(val.toLowerCase()) || item.store.organization.toString().includes(val.toLowerCase())) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    const generateReport = async (exportType:string) => {
        if (!exportType || !account || !account.isAuthenticated) return;

        setModalLoading(true);
        let param = {
            type: exportType
        };
        
        let result = await fetchProductAboutToExpireReport(account.token, param);

        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `all_about_to_expire_products.${result.data.type.split("/")[1]}`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            toast("Report generated");
        }
        setModalLoading(false);
    }

    return (
        <>
            <PageBodyHeader title="About To Expire Products" desc="Checklist of all about to expire products" >
                <button className="product_create_button" style={{color:"#FFF", backgroundColor:"#676967", borderColor:"#676967"}} onClick={() => window.history.back()}>
                    <span>Back</span>
                </button>
            </PageBodyHeader>

            <div>
                <Table table_head={["S/no", "Order code", "Product name", "Size", "Store", "Quantity", "Expiry Date"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
                tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
                tableAction={<ExportData export_type={(val) => processExport(val)} />}
                headerStyle={{marginBottom: "44px"}}
                table_title={`All Products About to expire`}
                >
                    <>
                        {productList.map((item, index) => (
                            (item.show || item.show === undefined) && (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>#{item.expiry_id}</td>
                                    <td>
                                        <div className="contentWithImg">
                                            <span><img src={item.image} alt={item.name} /></span>
                                            <span>{item.name}</span>
                                        </div>
                                    </td>
                                    <td>{item.size}</td>
                                    <td>{item.store.name} - {item.store.organization}</td>
                                    <td>{item.quantity}</td>
                                    <td>{dateStr(item.expiry_date)}</td>
                                </tr>
                            )
                        ))}
                    </>
                </Table>
            </div>
        </>
    )
}

export default VendorAllAboutToExpire;